'use strict';

// default datepicker options
app.config(function (datepickerConfig, datepickerPopupConfig) {
  datepickerConfig.showWeeks = false;
  datepickerPopupConfig.appendToBody = true;
  datepickerPopupConfig.showButtonBar = false;
  datepickerPopupConfig.datepickerPopup = 'dd/MM/yyyy';
});

